import classes from "./InfoCard.module.scss";
import LoadingBar from "../LoadingBar";
import hourglassIcon from "../../static/images/hourglass-icon.svg";

const InfoCard = ({
  title,
  time = null,
  variant = "default",
  subtitle = null,
  timer = null,
  isProgressing = false,
  etaProgress = 0,
  isLoading = false,
  progress,
  children,
  className,
  onClick,
  isFemaleDriver,
  disabled = false,
}) => {
  return (
    <div
      className={`${classes.infoCard}
        ${classes[variant]}
        ${disabled ? classes.infoCardDisabled : ""}
        ${className}`}
      onClick={onClick}
    >
      <div
        className={`${classes.infoCardHeader} ${
          time ? classes.infoCardHeaderWithTime : ""
        } ${isFemaleDriver ? classes.femaleDriverHeader : ""}`}
      >
        <p className={classes.infoCardTitle}>{title}</p>
        {time && <p className={classes.orderTime}>{time}</p>}
        {subtitle && <p className={classes.infoCardSubtitle}>{subtitle}</p>}
        {timer && (
          <p className={classes.infoCardSubtitle}>
            You have{" "}
            <span
              className={`${classes.timer} ${
                timer < 10 ? classes.timerDanger : ""
              }`}
            >
              {timer}
            </span>{" "}
            seconds to respond...
          </p>
        )}
      </div>
      <div className={`${classes.infoCardBody} ${className}`}>
        
        {(isProgressing || isLoading) && (
          <div className={classes.LoadingBarContainer}>
            {isProgressing && <img src={hourglassIcon} width={40} height={40} />}
            <LoadingBar isLoading={isLoading || isProgressing} 
                progress={progress} />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default InfoCard;
